import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {cloudLight} from '/theme/color/on.color';
import {getFontFamily} from '/util/text.util';

export const styles = StyleSheet.create({
  base: {},
  loadingBoxWellnessCredits: {
    height: 30,
    width: 130,
  },
  header: {
    paddingTop: indent,
  },
  loadingBoxExpirationAmount: {
    height: 20,
    width: 100,
  },
  loadingBoxExpirationDate: {
    height: 20,
    width: 140,
  },
  heading: {
    marginBottom: 10,
    ...getFontFamily('normal'),
  },
  listItemHeader: {
    paddingTop: indent,
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
  listItem: {
    borderBottomWidth: 1,
    borderBottomColor: cloudLight,
  },
});
